import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { MessageService } from "primeng/api";
import { Observable } from "rxjs";
import { map } from 'rxjs/operators';
import { ClientData } from "src/app/models/client-data/client-data";
import { CustomersRequest } from "src/app/models/client-data/customers-request";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: 'root'
})
export class ClientDataService {

  private apiUrl = environment.apiUrl;
  private clientData: ClientData = new ClientData();
  private locationLockedByDocument: boolean = false;
  private lockedLocationZip: string = "";
  private locationAdjustmentRequired: boolean = false;
  private consultPerformed: boolean = false;
  private consultedDocument: string = "";

  constructor(private httpClient: HttpClient, private messageService: MessageService) {
  }

  setClientData(clientData: ClientData) {
    this.clientData = clientData;
  }

  getClientData(): ClientData {
    return this.clientData;
  }

  getClientDataClean() {
    this.clientData = new ClientData();
    this.clearConsultState();
    this.clearLocationAdjustmentRequired();
  }

  setConsultState(performed: boolean, document: string): void {
    this.consultPerformed = performed;
    this.consultedDocument = (document || '').trim();
  }

  getConsultState(): { performed: boolean; document: string } {
    return {
      performed: this.consultPerformed,
      document: this.consultedDocument
    };
  }

  clearConsultState(): void {
    this.consultPerformed = false;
    this.consultedDocument = "";
  }

  setLocationLockState(locked: boolean, zipCode: string): void {
    this.locationLockedByDocument = locked;
    this.lockedLocationZip = zipCode;
  }

  getLocationLockState(): { locked: boolean; zipCode: string } {
    return {
      locked: this.locationLockedByDocument,
      zipCode: this.lockedLocationZip
    };
  }

  clearLocationLockState(): void {
    this.locationLockedByDocument = false;
    this.lockedLocationZip = "";
  }

  setLocationAdjustmentRequired(required: boolean): void {
    this.locationAdjustmentRequired = required;
  }

  consumeLocationAdjustmentRequired(): boolean {
    const required = this.locationAdjustmentRequired;
    this.locationAdjustmentRequired = false;
    return required;
  }

  clearLocationAdjustmentRequired(): void {
    this.locationAdjustmentRequired = false;
  }

  getCustomers(country: string, nationalId: string): Observable<ClientData> {

    const customersRequest = new CustomersRequest();
    customersRequest.country = country;
    customersRequest.nationalId = nationalId;

    return this.httpClient.post<ClientData>(`${this.apiUrl}/api/v2/customers/id`, customersRequest)
      .pipe(
        map((response: ClientData) => {
          return response;
        })
      );
  }
}